import { axiosInstance } from "../../axios/axiosInstance";

// Sources that should always show (explicit user action, not an autopopup).
const ALWAYS_SHOW_SOURCES = ["manual"];

// Returns the local calendar day as "YYYY-MM-DD".
const today = () => {
  const d = new Date();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${month}-${day}`;
};

const lsKey = (source, userId) => `fb_${source}_${userId || "anon"}`;

export const hasRecentCheck = (source, userId) => {
  try {
    if (ALWAYS_SHOW_SOURCES.includes(source)) return false;
    const lastDay = localStorage.getItem(lsKey(source, userId));
    if (!lastDay) return false;
    // Already shown today -> suppress until the next calendar day.
    return lastDay === today();
  } catch (e) {
    return false;
  }
};

export const markChecked = (source, userId) => {
  try {
    if (ALWAYS_SHOW_SOURCES.includes(source)) return;
    localStorage.setItem(lsKey(source, userId), today());
  } catch (e) {}
};

export const clearFeedbackFlag = (source, userId) => {
  try {
    localStorage.removeItem(lsKey(source, userId));
  } catch (e) {}
};

export const checkFeedbackEligibility = async (userId, source) => {
  try {
    const res = await axiosInstance.get("CustomerFeedback/CheckEligibility", {
      params: { userId, source },
    });
    return !!(res && res.data && res.data.eligible);
  } catch (e) {
    return false;
  }
};

export const submitFeedback = async (payload) => {
  try {
    const res = await axiosInstance.post("CustomerFeedback/SubmitFeedback", payload);
    return res && String(res.data).trim() === "1";
  } catch (e) {
    return false;
  }
};

// Server-driven suppression (progressive back-off). Identity comes from the JWT,
// so no userId is sent. A non-OK / 401 response resolves to false = do not show.
export const shouldShowFeedback = async () => {
  try {
    const res = await axiosInstance.get("CustomerFeedback/ShouldShow");
    return !!(res && res.data && res.data.show);
  } catch (e) {
    return false;
  }
};

export const dismissFeedback = async (dontShow) => {
  try {
    await axiosInstance.post("CustomerFeedback/DismissFeedback", null, {
      params: { blockFeedback: !!dontShow },
    });
  } catch (e) {}
};
